export default {
  web: {
    name: 'web',
  },
  terminal: {
    name: 'terminal',
  },
  terminalLarge: {
    name: 'terminalLarge',
  },
  mobile: {
    name: 'mobile',
  },
};
